import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import ChartPrescriptionListItemCode from "./ChartPrescriptionListItemCode";

import bindActions from "../../../../helpers/bindActions";
import * as chartSidePrescriptionActions from "../../../../actions/chartSidePrescriptionActions";
import { SidebarHeader } from "../../../sidebar/SidebarHeader";

const enhancer = connect(() => ({}), bindActions({ chartSidePrescriptionActions }));
export default enhancer(
  class ChartPrescriptionFavoriteList extends React.Component {
    static propTypes = {
      chartSidePrescriptionActions: PropTypes.object,
    };

    componentDidMount() {
      this.props.chartSidePrescriptionActions.initList();
    }

    openItem = (item) => {
      // document.location.href = item.pdfUrl;
      // this.props.chartSidePrescriptionActions.openPDF(item); //todo http-header
      this.props.chartSidePrescriptionActions.openItem(item.id);
    };

    toggleFavourite = (item) => {
      const favourites = JSON.parse(localStorage.getItem("PrescriptionFavourites"));

      if (!favourites[item.id]) {
        favourites[item.id] = item;
      }

      favourites[item.id].selected = !favourites[item.id].selected;

      localStorage.setItem("PrescriptionFavourites", JSON.stringify(favourites));

      this.forceUpdate();
    };

    render() {
      const list = JSON.parse(localStorage.getItem("PrescriptionFavourites"));

      const $list = [];

      _.forEach(list, (item, index) => {
        if (item && item.selected) {
          $list.push(
            <ChartPrescriptionListItemCode
              key={index}
              item={item}
              toggleFavourite={(item) => this.toggleFavourite(item)}
              openItem={() => this.openItem(item)}
            />,
          );
        }
      });

      return (
        <div className="chart-clinical-note">
          <SidebarHeader
            title="Favourite Prescriptions"
            onBackClick={this.props.chartSidePrescriptionActions.popStack}
          />
          <div className="chart-side-body">
            <div
              className="body"
              style={{
                overflowX: "hidden",
                overflowY: "auto",
              }}
            >
              {$list}
            </div>
            <div className="group-buttons">
              <button
                onClick={this.props.chartSidePrescriptionActions.openCategory}
                className="btn btn-primary btn-block"
              >
                Rx Templates
              </button>
              <button
                onClick={this.props.chartSidePrescriptionActions.openGroups}
                className="btn btn-primary btn-block"
              >
                Rx Groups
              </button>
              <button
                onClick={this.props.chartSidePrescriptionActions.openEmpty}
                className="btn btn-primary btn-block"
              >
                Write New
              </button>
            </div>
          </div>
        </div>
      );
    }
  },
);
